setInterval(function () {
  const countdownElements = document.querySelectorAll(
    ".product-detail-countdown"
  );
  if (countdownElements) {
    const now = new Date();
    const weekDay = now.getDay();
    const late = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      18,
      30,
      0
    );
    let seconds = (late.getTime() - now.getTime()) / 1000;
    let countdownElement = "";
    if (weekDay >= 1 && weekDay <= 5) {
      if (seconds <= 0) {
        countdownElement =
          "Order placed now will be shipped by tomorrow 7:00 PM Eastern Time (ET)";
      } else {
        const hours = Math.floor(seconds / 3600);
        seconds %= 3600;
        const minutes = Math.floor(seconds / 60);
        seconds %= 60;
        countdownElement = `Ships <b>today</b> if ordered within the next: <b>${hours}</b> hours <b>${minutes}</b> minutes <b>${Math.floor(
          seconds
        )}</b> minutes`;
      }
    } else {
      countdownElement =
        "Order placed today will be shipped by Monday 7:00 PM Eastern Time (ET)";
    }
    if (countdownElement) {
      countdownElements.forEach((e) => {
        // e.innerHTML = `<i class="fa-regular fa-timer fs-3"></i><span>${countdownElement}</span>`;
        e.innerHTML = `<span>${countdownElement}</span>`;
      });
    }
  }
}, 0);
